import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic-map-minus",
  "use": "icon-ic-map-minus-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-ic-map-minus\"><rect x=\"3.332\" y=\"9.167\" width=\"13.333\" height=\"1.667\" rx=\".833\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol